import type { Game } from '@hoopify/shared';

/** "Won 42–38", "Lost 30–41", "Drew 40–40", or PlayHQ's status when it's not a normal game. */
export function gameResult(g: Pick<Game, 'scoreUs' | 'scoreThem' | 'outcome' | 'playhqStatus'>): { text: string; tone: 'ok' | 'danger' | 'muted' } | null {
  const status = g.playhqStatus?.toUpperCase() ?? null;
  if (status === 'CANCELLED' || status === 'ABANDONED' || status === 'POSTPONED') return { text: status.charAt(0) + status.slice(1).toLowerCase(), tone: 'muted' };
  if (g.scoreUs == null || g.scoreThem == null) return status === 'FORFEIT' ? { text: 'Forfeit', tone: 'muted' } : null;
  const o = g.outcome?.toUpperCase() ?? (g.scoreUs > g.scoreThem ? 'WIN' : g.scoreUs < g.scoreThem ? 'LOSS' : 'DRAW');
  const score = `${g.scoreUs}–${g.scoreThem}`;
  if (o === 'WIN') return { text: `Won ${score}`, tone: 'ok' };
  if (o === 'LOSS') return { text: `Lost ${score}`, tone: 'danger' };
  return { text: `Drew ${score}`, tone: 'muted' };
}

export const RESULT_TONE = { ok: 'text-ok', danger: 'text-danger', muted: 'text-muted' } as const;
